import styles from "./index.module.scss";
import { NextPage } from "next";
import StockCommodity from "@/components/stock-commodity/StockCommodity";
import { Stock } from "@/models/stock";
import Head from "next/head";
import { buildStockOgImage } from "@/lib/stock-og";
import { useSetAtom } from "jotai";
import { stockTradingItemIdState } from "@/lib/store";
import { useEffect } from "react";
import { stockPageGetServerSideProps } from "@/lib/stock-page-ssr";
import { stockCanonicalUrl } from "@/lib/stock-url";

const StockCommodityPage: NextPage<{ stock: Stock }> = ({ stock }) => {
    const setStockTradingItemId = useSetAtom(stockTradingItemIdState);

    useEffect(() => {
        stock ? setStockTradingItemId(stock.tradingitem_id) : setStockTradingItemId(null);
    }, [stock]);
    return (
        <>
            {stock &&
                (() => {
                    const { ogImageUrl, cardTitle } = buildStockOgImage(stock, "Commodity Exposure");
                    return (
                        <Head>
                            <title>{`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | Commodity Exposure | ORTEX`}</title>
                            <link rel="canonical" href={stockCanonicalUrl(stock, "commodity-exposure")} />
                            <meta name="keywords" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker}, Commodity Exposure, Commodity risk`} />
                            <meta name="description" content={`Commodity Exposure and correlations for ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | Commodity Exposure | ORTEX`} />
                            <meta name="twitter:description" content={`Commodity Exposure and correlations for ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta name="twitter:url" content={stockCanonicalUrl(stock, "commodity-exposure")} />
                            <meta name="twitter:image" content={ogImageUrl} />
                            <meta name="twitter:image:alt" content={cardTitle} />
                            <meta property="og:title" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker} | Commodity Exposure | ORTEX`} />
                            <meta property="og:description" content={`Commodity Exposure and correlations for ${stock.name}, ${stock.exchangesymbol}:${stock.ticker}`} />
                            <meta property="og:url" content={stockCanonicalUrl(stock, "commodity-exposure")} />
                            <meta property="og:image" content={ogImageUrl} key="og:image" />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:image:alt" content={cardTitle} />
                        </Head>
                    );
                })()}
            <div className={styles.StockCommodityPage}>{stock ? <StockCommodity stock={stock} /> : <h1>Stock not found.</h1>}</div>
        </>
    );
};

export const getServerSideProps = stockPageGetServerSideProps({ tab: "commodity-exposure", allowedTypes: [1] });

export default StockCommodityPage;
